/*
 * @Descripttion: 
 * @version: 
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-07-28 10:48:07
 * @LastEditors: K
 * @LastEditTime: 2022-08-31 17:14:31
 */

import { unwrapResult } from '@reduxjs/toolkit';
import { Col, DatePicker, Form, Input, Modal, Row, Select, Table } from 'antd';
import moment from 'moment';
import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootDispatch } from '../../app/store';
import { EditableList } from '../../compnents/list/EditableList';
import { stringTrim } from '../../utils/StringUtils';
import { getAddEditType, getOrganizationName } from '../replaceMakeCenter/ReplaceMakeSupplierSclice';
import { getTenantServerEndTimeFn, getTimeShow } from './serviceDelaySlice';
import styles from "./Tenants.module.css";
import { getTenantList, selectTenantPage } from './tenantSlice';


const { Option } = Select;
const { TextArea } = Input;

interface OrderAddModalProps {
  visible: boolean;
  productPriceModalList: any
  defaultProductId?: number
  onOk: (obj: any) => void;
  onCancel: () => void;
}

export const OrderAddModal = ({
  visible,
  productPriceModalList,
  defaultProductId,
  onOk,
  onCancel,
}: OrderAddModalProps): ReactElement => {

  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const page = useSelector(selectTenantPage)

  const [confirmLoading, setConfirmLoading] = useState(false)   //确定按钮 loading

  const [tenantOptions, setTenantOptions] = useState<any>() // 机构名称

  const [dateStr, setDateStr] = useState('年')     //时长单位

  const [timeStatus, setTimeStatus] = useState<any>(null)    //开始结束时间是否展示

  const [timeProductId, setTimeProductId] = useState(null)    //产品类型 ID

  const [timeTenantId, setTimeTenantId] = useState<any>(null)    //机构 ID

  const [durationUnit, setDurationUnit] = useState(0)    //时长单位代码

  const [disabledType, setDisabledType] = useState(0)    //表单禁用

  const [serveEndTime, setServeEndTime] = useState<any>(null)    //服务结束时间

  const totalNum = () => {  //计算实收金额 总金额
    const price = form.getFieldValue('price')   //单价
    const durationNum = form.getFieldValue('durationNum')  //时长
    const discountNum = form.getFieldValue('discountNum') || 1   //折扣，未输入时默认传1
    // const amount = form.getFieldValue('amount')   //折扣

    console.log(discountNum, 'discountNum');

    const totalAmount = form.getFieldValue('totalAmount')   //总金额
    if (price && durationNum) {
      form.setFieldsValue({
        totalAmount: Number(price) * Number(durationNum)
      })
    }
  }

  const getTimeShowFn = (obj: any) => {
    dispatch(
      getTimeShow(obj)).then(unwrapResult)
      .then(res => setTimeStatus(res))
  }

  // 获取服务结束时间
  const fetchTenantServerEndTime = async (tenantId: any, productId: any) => {
    dispatch(getTenantServerEndTimeFn({ tenantId: Number(tenantId), productId: Number(productId) }))
      .then(unwrapResult)
      .then((res: any) => {
        if (res?.productId == -1) {
          setServeEndTime(new Date())
        } else {
          setServeEndTime(res?.serveEndTime)
        }
      })
  }

  // 监听 timeStatus 和 serveEndTime 的变化，设置开始时间
  useEffect(() => {
    console.log("12121212")
    if (timeStatus == 1 && serveEndTime) {
      form.setFieldsValue({
        startTime: moment(serveEndTime)
      })
    }
  }, [timeStatus, serveEndTime])

  const dateText = (num: number) => {
    switch (num) {
      case 0:
        setDateStr('年');
        break;
      case 1:
        setDateStr('日');
        break;
      case 2:
        setDateStr('次');
        break;
      case 3:
        setDateStr('个');
        break;
    }
  }



  useEffect(() => {
    if (visible) {   //打开弹窗清空状态
      form.resetFields()
      setDateStr('年')
      setConfirmLoading(false)
      setTimeStatus(null)
      setTimeProductId(null)
      setTimeTenantId(null)
      // 弹窗显示时获取机构列表数据
      dispatch(getTenantList({ current: 1,status: 1 }))

      // 如果有默认产品ID，自动选中
      if (defaultProductId) {
        form.setFieldsValue({ productId: defaultProductId })
        const arr = productPriceModalList.filter((item: any) => item.id == defaultProductId)
        if (arr.length > 0) {
          dateText(arr[0].durationUnit)
          setDurationUnit(arr[0].durationUnit)
          form.setFieldsValue({
            price: arr[0].defaultPrice,
            durationNum: arr[0].disabledType == 1 ? 1 : '',
            amount: defaultProductId === 2 ? 0 : undefined
          })
          setDisabledType(arr[0].disabledType)
          setTimeProductId(arr[0].id)
          setTimeStatus(arr[0].timeStatus)
        }
      }
    }
  }, [visible])

  useEffect(() => {
    setTenantOptions([...page.items])
  }, [visible, page])
  return (
    <div >
      <Modal width={600} destroyOnClose title="新增订单" confirmLoading={confirmLoading} visible={visible} onOk={() => {
        form.submit()

      }} onCancel={() => onCancel()}>

        <div>
          <Form
            form={form}
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 16 }}

            onFinish={(values) => {
              values.startTime = timeStatus == 1 ? moment(values.startTime).format('YYYY-MM-DD') : undefined
              // 处理到期时间
              if (values.endTime) {
                // 确保时分秒为23:59:59
                const endTime = moment(values.endTime).hour(23).minute(59).second(59)
                values.endTime = endTime.format('YYYY/MM/DD HH:mm:ss') // 转换为String类型，格式为yyyy/MM/dd HH:mm:ss
              } else {
                values.endTime = undefined
              }
              // 折扣未输入时默认传1
              if (values.discountNum === undefined || values.discountNum === '') {
                values.discountNum = 1
              }
              setConfirmLoading(true)
              onOk(values)
            }}
          >
            <Row>
              <Col span={24}>
                <Form.Item
                  label='机构名称'
                  name='tenantId'
                  rules={[{ required: true, message: '请选择合作机构!' }]}
                >
                  <Select
                    showSearch
                    placeholder='请选择合作机构'
                    defaultActiveFirstOption={false}
                    showArrow={false}
                    filterOption={false}
                    onSearch={(v: string) => {
                      dispatch(
                        getTenantList({ name: v ,status: 1}
                        ))
                    }}
                    onChange={(v) => {
                      setTimeTenantId(v)
                      timeProductId && getTimeShowFn({
                        tenantId: v,
                        productId: timeProductId
                      })
                      // 获取服务结束时间
                      if (v && timeProductId) {
                        fetchTenantServerEndTime(v, timeProductId).then(endTime => {
                          setServeEndTime(endTime)
                        })
                      }
                    }}
                  >
                    {tenantOptions?.map((el: any) => (
                      <Select.Option key={el.id} value={el.id}>
                        {el.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item name='productId' label="产品类型" rules={[{ required: true, message: '请选择产品类型!' }]}>
                  <Select
                    placeholder="请选择产品类型"
                    onChange={(value) => {

                      // 时长单位
                      const arr = productPriceModalList.filter((item: any) => item.id == value)
                      dateText(arr[0].durationUnit)
                      setDurationUnit(arr[0].durationUnit)
                      form.setFieldsValue({
                        price: arr[0].defaultPrice,
                        totalAmount: '',
                        amount: value === 2 ? 0 : '',
                        durationNum: arr[0].disabledType == 1 ? 1 : '',
                        discountNum: ''
                      })

                      // 表单是否禁用
                      setDisabledType(arr[0].disabledType)
                      console.log(arr[0], '123');

                      // 是否显示开始结束时间
                      setTimeProductId(arr[0].id)
                      timeTenantId && getTimeShowFn({
                        tenantId: timeTenantId,
                        productId: arr[0].id
                      })
                      setTimeStatus(arr[0].timeStatus)
                      // 获取服务结束时间
                      if (timeTenantId && arr[0].id) {
                        fetchTenantServerEndTime(timeTenantId, arr[0].id).then(endTime => {
                          setServeEndTime(endTime)
                        })
                      }
                    }}
                  >
                    {productPriceModalList?.map((el: any) => (
                      <Select.Option key={el.id} value={el.id}>
                        {el.productName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item name='price' label="单价" rules={[
                  {
                    required: true,
                    pattern: disabledType == 1 ? /^([0-9][0-9]*)$/ : /^([0-9][0-9]*)$/,
                    message: "请输入正整数!",
                  },
                ]} getValueFromEvent={stringTrim}>
                  <Input
                    disabled={false}
                    placeholder='请输入单价'
                    onChange={() => totalNum()} />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24} style={{ position: 'relative', }}>
                <Form.Item name='durationNum' label="时长" rules={[
                  {
                    required: true,
                    pattern: /^([1-9][0-9]*)$/,
                    message: "请输入正整数!",
                  },
                ]} getValueFromEvent={stringTrim}>
                  <Input
                    suffix={dateStr}
                    disabled={disabledType == 1}
                    onChange={(e) => {
                      const value = e.target.value
                      totalNum()

                      form.getFieldValue('startTime') && form.setFieldsValue({
                        endTime: moment(form.getFieldValue('startTime')).add(value, 'years')
                      })

                      // 计算到期时间
                      if (value && (durationUnit === 0 || durationUnit === 1)) {
                        // 确定开始时间：优先使用服务结束时间，否则使用当前时间
                        let startTime
                        if (serveEndTime) {
                          startTime = moment(serveEndTime)
                        } else {
                          startTime = moment()
                        }
                        
                        let expirationTime
                        if (durationUnit === 0) {
                          // 年单位
                          expirationTime = startTime.add(Number(value), 'years')
                        } else if (durationUnit === 1) {
                          // 日单位
                          expirationTime = startTime.add(Number(value), 'days')
                        }
                        
                        // 设置时分秒为23:59:59
                        expirationTime = expirationTime.hour(23).minute(59).second(59)
                        
                        form.setFieldsValue({
                          endTime: expirationTime
                        })
                      } else if (durationUnit >= 2) {
                        // 其他单位不计算到期时间
                        form.setFieldsValue({
                          endTime: undefined
                        })
                      }
                    }} />
                </Form.Item>
              </Col>
            </Row>
            {timeStatus == 1 &&
              <>
                <Row>
                  <Col span={24}>
                    <Form.Item name='startTime' label="开始时间" rules={[
                      {
                        required: true,
                        message: "请选择开始时间!",
                      },
                    ]} >
                      <DatePicker style={{ width: '100%' }} onChange={(date) => {
                        form.setFieldsValue({
                          endTime: moment(date).add(Number(form.getFieldValue('durationNum') || 1), 'years')
                        })
                      }} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={24} style={{ position: 'relative', }}>
                    <Form.Item name='endTime' label="结束时间" rules={[
                      {
                        required: true,
                        message: "请选择结束时间!",
                      },
                    ]} getValueFromEvent={stringTrim}>
                      <DatePicker style={{ width: '100%' }} disabled />
                    </Form.Item>
                  </Col>
                </Row>
              </>}
            <Row>
              <Col span={24} style={{ position: 'relative', }}>
                <Form.Item name='totalAmount' label="总金额" getValueFromEvent={stringTrim}>
                  <Input disabled={false} onChange={() => totalNum()} />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24} style={{ position: 'relative', }}  >
                <Form.Item name='discountNum' label="折扣" rules={[
                  {
                    pattern: /^(0(\.\d{1,2})?|1(\.0{1,2})?)$/,
                    message: "请输入0-1之间的折扣范围!",
                  }
                ]} getValueFromEvent={stringTrim}>
                  <Input
                    placeholder='请输入折扣'
                    disabled={false}
                    onChange={() => totalNum()} />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24} style={{ position: 'relative', }}>
                <Form.Item name='amount' label="实收金额" rules={[{ required: true, message: '请输入实收金额!' }]} getValueFromEvent={stringTrim}>
                  <Input
                    disabled={false}
                    placeholder='请输入实收金额'
                    onChange={(e) => {
                      const value = e.target.value
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24} style={{ position: 'relative', }}>
                <Form.Item name='endTime' label="到期时间" rules={[
                  {
                    required: durationUnit < 2,
                    message: '请选择到期时间!',
                  },
                ]} getValueFromEvent={stringTrim}>
                  <DatePicker
                    style={{ width: '100%' }}
                    onChange={(date) => {
                      form.setFieldsValue({
                        endTime: date
                      })
                      // 系统赠送时，根据到期时间自动计算天数
                      if (timeProductId === 2) {
                        const startTime = serveEndTime ? moment(serveEndTime) : moment()
                        const days = Math.ceil(moment(date).diff(startTime, 'days', true))
                        form.setFieldsValue({
                          durationNum: days > 0 ? days : 0
                        })
                        totalNum()
                      }
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24} style={{ position: 'relative', }}>
                <Form.Item name='remark' label="备注" getValueFromEvent={stringTrim}>
                  <TextArea maxLength={200} />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>
    </div>
  );
}



